import { useTranslation } from 'react-i18next';
import { sentinel } from '@sentinel/ui';

const cardStyle: React.CSSProperties = {
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  gap: '1.25rem',
  alignItems: 'flex-start',
  flexWrap: 'wrap',
  padding: '1.5rem',
  borderRadius: '0.75rem',
  border: `1px solid ${sentinel.borderDefault}`,
  backgroundColor: sentinel.surfaceElevated,
  boxShadow: sentinel.shadowThin,
};

const iconChipStyle: React.CSSProperties = {
  flexShrink: 0,
  width: '3rem',
  height: '3rem',
  display: 'grid',
  placeItems: 'center',
  borderRadius: '0.625rem',
  color: sentinel.accentAction,
  backgroundColor: sentinel.surfaceOverlay,
  border: `1px solid ${sentinel.borderEmphasis}`,
};

const bodyStyle: React.CSSProperties = {
  flex: 1,
  minWidth: '16rem',
  display: 'grid',
  gap: '0.5rem',
};

const titleStyle: React.CSSProperties = {
  margin: 0,
  fontFamily: sentinel.fontDisplay,
  fontSize: '1.125rem',
  fontWeight: 600,
  letterSpacing: '-0.01em',
  color: sentinel.textBody,
};

const descStyle: React.CSSProperties = {
  margin: 0,
  fontFamily: sentinel.fontBody,
  fontSize: '0.9375rem',
  lineHeight: 1.55,
  color: sentinel.textMuted,
  maxWidth: '54ch',
};

const hintRowStyle: React.CSSProperties = {
  display: 'flex',
  gap: '0.5rem',
  alignItems: 'flex-start',
  marginBlockStart: '0.5rem',
  paddingBlockStart: '0.75rem',
  borderTop: `1px solid ${sentinel.borderDefault}`,
};

const hintIconStyle: React.CSSProperties = {
  flexShrink: 0,
  width: '1rem',
  height: '1rem',
  marginBlockStart: '0.15rem',
  color: sentinel.textSubtle,
};

const hintStyle: React.CSSProperties = {
  margin: 0,
  fontFamily: sentinel.fontBody,
  fontSize: '0.8125rem',
  lineHeight: 1.5,
  color: sentinel.textSubtle,
};

const shieldGlyphStyle: React.CSSProperties = { width: '1.5rem', height: '1.5rem' };

function ShieldCheckGlyph() {
  return (
    <svg
      style={shieldGlyphStyle}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12 3 5 6v5c0 4.2 2.9 7.7 7 9 4.1-1.3 7-4.8 7-9V6l-7-3Z" />
      <path d="m9 12 2 2 4-4" />
    </svg>
  );
}

function KeyGlyph() {
  return (
    <svg
      style={hintIconStyle}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="8" cy="15" r="4" />
      <path d="m10.8 12.2 8.2-8.2M16 6l2 2M19 3l2 2" />
    </svg>
  );
}

export function IdpManagedCard() {
  const { t } = useTranslation('security');
  return (
    <section style={cardStyle} data-testid="idp-managed-card">
      <div style={iconChipStyle} aria-hidden="true">
        <ShieldCheckGlyph />
      </div>
      <div style={bodyStyle}>
        <h2 style={titleStyle}>{t('idp_managed_title')}</h2>
        <p style={descStyle}>{t('idp_managed_body')}</p>
        <div style={hintRowStyle}>
          <KeyGlyph />
          <p style={hintStyle}>{t('idp_managed_hint')}</p>
        </div>
      </div>
    </section>
  );
}
